import { CButton } from "@coreui/react";

function BasicPagination({ currentPage, totalPages, onPageChange, maxVisiblePages = 10 }) {
    const getVisiblePages = () => {
        const delta = Math.floor(maxVisiblePages / 2);
        let start = currentPage - delta;
        let end = currentPage + delta;

        if (start < 1) {
            end += 1 - start;
            start = 1;
        }

        if (end > totalPages) {
            start -= end - totalPages;
            end = totalPages;
        }

        start = Math.max(start, 1);
        end = Math.min(end, totalPages);

        const pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const getPageButtonStyle = (page) => {
        const isCurrentPage = currentPage === page;
        const distance = Math.abs(currentPage - page);
        const maxDistance = Math.floor(maxVisiblePages / 2);
        const scale = Math.max(0.6, 1 - (distance * 0.15));
        const opacity = Math.max(0.3, 1 - (distance * 0.25));

        return {
            // transform: `scale(${scale})`,
            // opacity: opacity,
            width: isCurrentPage ? '80px' : '50px',
            backgroundColor: isCurrentPage ? 'rgba(255, 121, 25, 1)' : 'white',
            color: isCurrentPage ? 'white' : 'rgba(255, 121, 25, 1)',
            border: `1.5px solid rgba(255, 121, 25, 1)`,
            transition: 'all 0.3s ease'
        };
    };

    const visiblePages = getVisiblePages();

    return (
        <div style={{ 
            display: totalPages <= 1 ? 'none' : 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            gap: '10px', 
            marginTop: '20px' 
        }}>
            <CButton 
                onClick={handlePrevious} 
                disabled={currentPage === 1}
                style={{
                    backgroundColor: currentPage === 1 ? 'white' : 'rgba(255, 121, 25, 1)',
                    color: currentPage === 1 ? 'rgba(255, 121, 25, 1)' : 'white',
                    border: '1.5px solid rgba(255, 121, 25, 1)'
                }}
            >
                이전
            </CButton>

            {visiblePages.map(page => (
                <CButton
                    key={page}
                    onClick={() => onPageChange(page)}
                    style={getPageButtonStyle(page)}
                >
                    {page}
                </CButton>
            ))}

            <CButton 
                onClick={handleNext} 
                disabled={currentPage === totalPages}
                style={{
                    backgroundColor: currentPage === totalPages ? 'white' : 'rgba(255, 121, 25, 1)',
                    color: currentPage === totalPages ? 'rgba(255, 121, 25, 1)' : 'white',
                    border: '1.5px solid rgba(255, 121, 25, 1)'
                }}
            >
                다음
            </CButton>
        </div>
    );
}

export default BasicPagination;
